import { Injectable } from '@angular/core';
import { ActionDisabledCondition, ActionItemOptions, UserAction } from '@mediahaven/shared';
import { ApiFragment, NavigationLink } from '@stylehaven/components';
import { Observable, of } from 'rxjs';
import { MediaHavenActionType } from '../../../entities/action-types.entity';
import { ActionLinkService } from '../../abstract/action-link.service.interface';

@Injectable({ providedIn: 'root' })
export class OpenContentActionService extends ActionLinkService {
    protected action: MediaHavenActionType = MediaHavenActionType.OPEN_CONTENT;

    /*  Open collection content
     *  Available when:
     *   * Is collection
     *   * is NOT deleted
     *
     *  Disabled when:
     *   * Never
     */
    public getUserAction(record: ApiFragment): Observable<UserAction> {
        return of(this.userActionBuilder(record));
    }

    public override userActionBuilder(record: ApiFragment): UserAction {
        const isDeleted: boolean = record.isDeleted();
        const isIntellectual: boolean = record.isIntellectualObject();

        const availableConditions: boolean[] = [isIntellectual, !isDeleted];
        const disableConditions: ActionDisabledCondition[] = [];

        return new UserAction(availableConditions, disableConditions);
    }

    public getLabelKey(target: ApiFragment): string {
        return 'actions.intellectual.open';
    }

    protected getLink(record: ApiFragment, actionItemOptions: ActionItemOptions): Observable<NavigationLink> {
        const intellectualLink: string = actionItemOptions.shareContext
            ? record.getShareContentUrl(actionItemOptions.shareContext)
            : record.getContentUrl();

        const state: any = {
            queryIteratorStack: actionItemOptions.queryIteratorStack
        };

        return of({
            route: intellectualLink,
            extras: { state }
        });
    }
}
